import { ReactElement } from "react";
import {
  Box,
  ListItem,
  UnorderedList,
  Modal,
  ModalHeader,
  ModalHeading,
  ModalBody,
} from "@twilio-paste/core";

import { copy, types } from "./definitions";
import TrackingButton from "../trackingButton";

const PhoneNumbersModal = ({
  isOpen,
  phoneNumbers,
  togglePhoneModal,
}: types.PhoneNumbersModalProps): ReactElement => (
  <Box>
    <TrackingButton
      variant="primary"
      onClick={(): void => togglePhoneModal({ isOpen: true })}
    >
      {copy.modalButton}
    </TrackingButton>

    <Modal
      ariaLabelledby="phoneNumbersModal"
      isOpen={isOpen}
      onDismiss={(): void => togglePhoneModal({ isOpen: false })}
      size="default"
    >
      <ModalHeader>
        <ModalHeading as="h3">{copy.modalHeading}</ModalHeading>
      </ModalHeader>

      <ModalBody>
        <UnorderedList>
          {phoneNumbers.map((phone) => (
            <ListItem key={phone.number}>
              {copy.phoneNumbers.displayValue(phone)}
            </ListItem>
          ))}
        </UnorderedList>
      </ModalBody>
    </Modal>
  </Box>
);

export default PhoneNumbersModal;
